export type ChipColorSchema = {
    borderColor: string;
    bgColor: string;
    textColor: string;
}

export type ApointmentStaus =
    "Sin status" |
    "Confirmada" |
    "Cancelada" |
    "Reprogramada";

export type ProcessStaus =
    "No Contesto" |
    "Cancelada" |
    "Confirmada" |
    "Fallo" |
    "Esperando Respuesta" |
    "Sin Respuesta" |
    "No Iniciado";

export type AvailableColors =
    "gris" |
    "verde" |
    "rojo" |
    "amarillo" |
    "naranja" |
    "azul";

export const colorSchemas: Record<AvailableColors, ChipColorSchema> = {
    "gris": { borderColor: "border-gray-800", bgColor: "bg-gray-100", textColor: "text-gray-800"},
    "verde": { borderColor: "border-green-800", bgColor: "bg-green-100", textColor: "text-green-800"},
    "rojo": { borderColor: "border-red-800", bgColor: "bg-red-100", textColor: "text-red-800"},
    "amarillo": { borderColor: "border-yellow-800", bgColor: "bg-yellow-100", textColor: "text-yellow-800"},
    "naranja": { borderColor: "border-orange-800", bgColor: "bg-orange-100", textColor: "text-orange-800"},
    "azul": { borderColor: "border-blue-800", bgColor: "bg-blue-100", textColor: "text-blue-800"},
};

export const appointmentStatusColors: Record<ApointmentStaus, ChipColorSchema> = {
    "Sin status": colorSchemas.gris,
    "Confirmada": colorSchemas.verde,
    "Cancelada": colorSchemas.rojo,
    "Reprogramada": colorSchemas.amarillo,
}

export const processStatusColors: Record<ProcessStaus, ChipColorSchema> = {
    "No Contesto": colorSchemas.naranja,
    "Cancelada": colorSchemas.rojo,
    "Confirmada": colorSchemas.verde,
    "Fallo": colorSchemas.rojo,
    "Esperando Respuesta": colorSchemas.azul,
    "Sin Respuesta": colorSchemas.naranja,
    "No Iniciado": colorSchemas.gris,
}
